"use strict";

var _slicedToArray = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71;

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _nullishCoalesce(lhs, rhsFn) {
  if (lhs != null) {
    return lhs;
  } else {
    return rhsFn();
  }
}

function _optionalChain(ops) {
  var lastAccessLHS = undefined;
  var value = ops[0];
  var i = 1;

  while (i < ops.length) {
    var op = ops[i];
    var fn = ops[i + 1];
    i += 2;

    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined;
    }

    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn(function () {
        var _value;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (_value = value).call.apply(_value, [lastAccessLHS].concat(args));
      });
      lastAccessLHS = undefined;
    }
  }

  return value;
}

var B = {
  name: "Browse By",
  subLinks: [{
    href: "/todays-auctions",
    name: "Today's Events"
  }, {
    href: "/live-auctions",
    name: "Live Auctions"
  }, {
    href: "/timed-events",
    name: "Timed Auctions"
  }, {
    href: "/all-auctions",
    name: "All Events"
  }, {
    href: "/asp/auction-companies.asp",
    name: "Auction Houses"
  }, {
    href: "/auctions-near-me-map",
    name: "Auctions Near Me"
  }, {
    href: "/asp/featured-lots.asp",
    name: "Featured Items"
  }]
},
    D = exports.aboutAuctionsLinks = {
  name: "About Auctions",
  subLinks: [{
    href: "https://discover.proxibid.com/buying",
    name: "Buying"
  }, {
    href: "https://discover.proxibid.com/selling",
    name: "Selling"
  }, {
    href: "https://proxibid.zendesk.com",
    name: "Help"
  }]
},
    oe = exports.headerTopLeftLinks = [B, D],
    b = exports.myAccountLinks = {
  name: "My Account",
  subLinks: [{
    href: "/asp/Bidder/BidderHome.asp",
    name: "My Proxibid"
  }, {
    href: "sign-out",
    name: "Sign Out"
  }]
},
    S = exports.myWatchListLink = {
  href: "/asp/Bidder/PrebidManage.asp?opt=1",
  name: "My Watchlist"
};
var E = [{
  href: "/for-sale/heavy-construction-equipment",
  name: "Construction",
  subCategories: [[{
    name: "Heavy Construction Equipment",
    subLinks: [{
      href: "/for-sale/heavy-construction-equipment",
      name: "All Heavy Construction Equipment"
    }, {
      href: "/for-sale/heavy-construction-equipment/asphalt-concrete-equipment",
      name: "Asphalt & Concrete Equipment"
    }, {
      href: "/for-sale/heavy-construction-equipment/bulldozers",
      name: "Bulldozers"
    }, {
      href: "/for-sale/heavy-construction-equipment/construction-equipment-attachments",
      name: "Construction Equipment Attachments"
    }, {
      href: "/for-sale/heavy-construction-equipment/cranes",
      name: "Cranes"
    }, {
      href: "/for-sale/heavy-construction-equipment/drilling-mining-equipment",
      name: "Drilling & Mining Equipment"
    }, {
      href: "/for-sale/heavy-construction-equipment/excavators",
      name: "Excavators"
    }, {
      href: "/for-sale/heavy-construction-equipment/forestry-logging-equipment",
      name: "Forestry & Logging Equipment"
    }, {
      href: "/for-sale/heavy-construction-equipment/lifts",
      name: "Lifts"
    }, {
      href: "/for-sale/heavy-construction-equipment/light-equipment-support",
      name: "Light Equipment & Support"
    }, {
      href: "/for-sale/heavy-construction-equipment/loaders",
      name: "Loaders"
    }, {
      href: "/for-sale/heavy-construction-equipment/skid-steers",
      name: "Skid Steers"
    }]
  }], [{
    name: "Popular Categories",
    subLinks: [{
      href: "/for-sale/heavy-construction-equipment/building-materials",
      name: "Building Materials"
    }, {
      href: "/for-sale/heavy-construction-equipment/construction-aggregates",
      name: "Construction Aggregates"
    }, {
      href: "/for-sale/heavy-construction-equipment/construction-trailers",
      name: "Construction Trailers"
    }, {
      href: "/for-sale/heavy-construction-equipment/landscape-commercial-lawncare",
      name: "Landscape & Commercial Lawncare"
    }, {
      href: "/for-sale/heavy-construction-equipment/off-road-dump-haul-trucks",
      name: "Off Road Dump & Haul Trucks"
    }, {
      href: "/for-sale/heavy-construction-equipment/power-tools",
      name: "Power Tools"
    }, {
      href: "/for-sale/heavy-construction-equipment/pumps",
      name: "Pumps"
    }, {
      href: "/for-sale/heavy-construction-equipment/scissor-lifts",
      name: "Scissor Lifts"
    }, {
      href: "/for-sale/heavy-construction-equipment/skid-steer-attachments",
      name: "Skid Steer Attachments"
    }, {
      href: "/for-sale/heavy-construction-equipment/tools",
      name: "Tools"
    }]
  }]]
}, {
  href: "/for-sale/farm-equipment-machinery",
  name: "Farm Equipment",
  subCategories: [[{
    name: "Farm Equipment",
    subLinks: [{
      href: "/for-sale/farm-equipment-machinery",
      name: "All Farm Equipment"
    }, {
      href: "/for-sale/farm-equipment-machinery/applicators-sprayers",
      name: "Applicators & Sprayers"
    }, {
      href: "/for-sale/farm-equipment-machinery/farm-wagons-trailers",
      name: "Farm Wagon & Trailers"
    }, {
      href: "/for-sale/farm-equipment-machinery/grain-feed-handling",
      name: "Grain & Feed Handling"
    }, {
      href: "/for-sale/farm-equipment-machinery/harvest-equipment",
      name: "Harvest Equipment"
    }, {
      href: "/for-sale/farm-equipment-machinery/hay-forage-equipment",
      name: "Hay & Forage Equipment"
    }, {
      href: "/for-sale/farm-equipment-machinery/livestock-supplies",
      name: "Livestock Supplies"
    }, {
      href: "/for-sale/farm-equipment-machinery/planters-seeding",
      name: "Planters & Seeding"
    }, {
      href: "/for-sale/farm-equipment-machinery/tractors",
      name: "Tractors"
    }]
  }], [{
    name: "Popular Categories",
    subLinks: [{
      href: "/for-sale/farm-equipment-machinery/combines-harvesters",
      name: "Combines & Harvesters"
    }, {
      href: "/for-sale/farm-equipment-machinery/grain-feed-storage",
      name: "Grain & Feed Storage"
    }, {
      href: "/for-sale/farm-equipment-machinery/hay-balers-equipment",
      name: "Hay Balers & Equipment"
    }, {
      href: "/for-sale/farm-equipment-machinery/headers-platforms",
      name: "Headers & Platforms"
    }, {
      href: "/for-sale/farm-equipment-machinery/seeders",
      name: "Seeders"
    }]
  }]]
}, {
  href: "/for-sale/commercial-trucks",
  name: "Commercial Trucks",
  subCategories: [[{
    name: "Commercial Trucks",
    subLinks: [{
      href: "/for-sale/commercial-trucks",
      name: "All Commercial Trucks"
    }, {
      href: "/for-sale/commercial-trucks/bucket-trucks",
      name: "Bucket Trucks"
    }, {
      href: "/for-sale/commercial-trucks/commercial-truck-trailers",
      name: "Commercial Truck Trailers"
    }, {
      href: "/for-sale/commercial-trucks/asphalt-concrete-trucks",
      name: "Concrete & Asphalt Trucks"
    }, {
      href: "/for-sale/commercial-trucks/electric-communication-trucks",
      name: "Electric & Communication Trucks"
    }, {
      href: "/for-sale/commercial-trucks/forestry-trucks",
      name: "Forestry Trucks"
    }, {
      href: "/for-sale/commercial-trucks/hauling-transport-trucks",
      name: "Hauling & Transport Trucks"
    }, {
      href: "/for-sale/commercial-trucks/service-utility-trucks",
      name: "Service & Utility Trucks"
    }, {
      href: "/for-sale/commercial-trucks/specialty-trucks",
      name: "Specialty Trucks"
    }, {
      href: "/for-sale/commercial-trucks/tow-recovery-trucks",
      name: "Tow & Recovery Trucks"
    }, {
      href: "/for-sale/commercial-trucks/truck-tractors",
      name: "Truck Tractors"
    }, {
      href: "/for-sale/commercial-trucks/van-cargo-trucks",
      name: "Van & Cargo Trucks"
    }, {
      href: "/for-sale/commercial-trucks/waste-water-trucks",
      name: "Waste & Water Trucks"
    }]
  }], [{
    name: "Popular Categories",
    subLinks: [{
      href: "/for-sale/commercial-trucks/box-trucks",
      name: "Box Trucks"
    }, {
      href: "/for-sale/commercial-trucks/digger-derrick-trucks",
      name: "Digger Derrick Trucks"
    }, {
      href: "/for-sale/commercial-trucks/dry-van-trailers",
      name: "Dry Van Trailers"
    }, {
      href: "/for-sale/commercial-trucks/dump-trailers",
      name: "Dump Trailers"
    }, {
      href: "/for-sale/commercial-trucks/dump-trucks",
      name: "Dump Trucks"
    }, {
      href: "/for-sale/commercial-trucks/flatbed-trucks",
      name: "Flatbed Trucks"
    }, {
      href: "/for-sale/commercial-trucks/gooseneck-trailers",
      name: "Gooseneck Trailers"
    }, {
      href: "/for-sale/commercial-trucks/flatbed-trailers",
      name: "Flatbed Trailers"
    }, {
      href: "/for-sale/commercial-trucks/reefer-trailers",
      name: "Reefer Trailers"
    }, {
      href: "/for-sale/heavy-construction-equipment/rollers",
      name: "Rollers"
    }, {
      href: "/for-sale/heavy-construction-equipment/shipping-containers",
      name: "Shipping Containers"
    }, {
      href: "/for-sale/commercial-trucks/work-trucks",
      name: "Work Trucks"
    }]
  }]]
}, {
  href: "/for-sale/industrial-machinery-equipment",
  name: "Industrial",
  subCategories: [[{
    name: "Industrial Machinery & Equipment",
    subLinks: [{
      href: "/for-sale/industrial-machinery-equipment",
      name: "All Industrial Machinery & Equipment"
    }, {
      href: "/for-sale/industrial-machinery-equipment/auto-repair-equipment",
      name: "Auto Repair Equipment"
    }, {
      href: "/for-sale/industrial-machinery-equipment/business-liquidations",
      name: "Business Liquidation"
    }, {
      href: "/for-sale/industrial-machinery-equipment/electrical-test-equipment",
      name: "Electrical & Test Equipment"
    }, {
      href: "/for-sale/industrial-machinery-equipment/event-equipment",
      name: "Event Equipment"
    }, {
      href: "/for-sale/industrial-machinery-equipment/food-beverage-service-equipment",
      name: "Food & Beverage Service Equipment"
    }, {
      href: "/for-sale/industrial-machinery-equipment/manufacturing-equipment",
      name: "Manufacturing Equipment"
    }, {
      href: "/for-sale/industrial-machinery-equipment/medical-lab-equipment",
      name: "Medical & Lab Equipment"
    }, {
      href: "/for-sale/industrial-machinery-equipment/office-equipment",
      name: "Office Equipment"
    }, {
      href: "/for-sale/industrial-machinery-equipment/return-pallets",
      name: "Return Pallets"
    }, {
      href: "/for-sale/industrial-machinery-equipment/waste-recycling-equipment",
      name: "Waste & Recycling Equipment"
    }, {
      href: "/for-sale/industrial-machinery-equipment/warehouse-retail-fixtures",
      name: "Warehouse & Retail Fixtures"
    }]
  }], [{
    name: "Popular Categories",
    subLinks: [{
      href: "/for-sale/industrial-machinery-equipment/bar-brewery-equipment",
      name: "Bar & Brewery Equipment"
    }, {
      href: "/for-sale/industrial-machinery-equipment/forklifts",
      name: "Forklifts"
    }, {
      href: "/for-sale/industrial-machinery-equipment/generators",
      name: "Generators"
    }, {
      href: "/for-sale/industrial-machinery-equipment/lab-equipment",
      name: "Lab Equipment"
    }, {
      href: "/for-sale/industrial-machinery-equipment/medical-equipment",
      name: "Medical Equipment"
    }, {
      href: "/for-sale/industrial-machinery-equipment/medical-office-furniture",
      name: "Medical Office Furniture"
    }, {
      href: "/for-sale/industrial-machinery-equipment/restaurant-commercial-kitchen-equipment",
      name: "Restaurant & Commercial Kitchen Equipment"
    }, {
      href: "/for-sale/industrial-machinery-equipment/sawmill-woodworking-equipment",
      name: "Sawmill & Woodworking Equipment"
    }]
  }]]
}, {
  href: "/for-sale/cars-vehicles",
  name: "Vehicles",
  subCategories: [[{
    name: "Collector Cars",
    subLinks: [{
      href: "/for-sale/collector-cars",
      name: "All Collector Cars"
    }, {
      href: "/for-sale/collector-cars/antique-cars",
      name: "Antique Cars"
    }, {
      href: "/for-sale/collector-cars/classic-vintage-cars",
      name: "Classic & Vintage Cars"
    }, {
      href: "/for-sale/collector-cars/collector-motorcycles",
      name: "Collector Motorcycles"
    }, {
      href: "/for-sale/collector-cars/classic-trucks",
      name: "Classic Trucks"
    }, {
      href: "/for-sale/collector-cars/exotic-cars",
      name: "Exotic Cars"
    }, {
      href: "/for-sale/collector-cars/muscle-performance-cars",
      name: "Muscle & Performance Cars"
    }]
  }], [{
    name: "Cars & Vehicles",
    subLinks: [{
      href: "/for-sale/cars-vehicles",
      name: "All Cars & Vehicles"
    }, {
      href: "/for-sale/cars-vehicles/airplanes-helicopters",
      name: "Airplanes & Helicopters"
    }, {
      href: "/for-sale/cars-vehicles/boats-watercrafts",
      name: "Boats & Watercraft"
    }, {
      href: "/for-sale/cars-vehicles/buses",
      name: "Buses"
    }, {
      href: "/for-sale/cars-vehicles/cars",
      name: "Cars"
    }, {
      href: "/for-sale/cars-vehicles/motorcycles",
      name: "Motorcycles"
    }, {
      href: "/for-sale/cars-vehicles/recreational-vehicles",
      name: "Recreational Vehicles"
    }, {
      href: "/for-sale/cars-vehicles/trucks",
      name: "Trucks"
    }]
  }], [{
    name: "Popular Categories",
    subLinks: [{
      href: "/for-sale/cars-vehicles/fishing-boats",
      name: "Fishing Boats"
    }, {
      href: "/for-sale/cars-vehicles/passenger-vans",
      name: "Passenger Vans"
    }, {
      href: "/for-sale/cars-vehicles/power-motorboats",
      name: "Power & Motorboats"
    }, {
      href: "/for-sale/cars-vehicles/rv-s",
      name: "RVs"
    }, {
      href: "/for-sale/cars-vehicles/suv-s",
      name: "SUVs"
    }, {
      href: "/for-sale/cars-vehicles/utility-vehicles",
      name: "Utility Vehicles"
    }]
  }]]
}, {
  href: "/for-sale/estate-personal-property",
  name: "Estate",
  subCategories: [[{
    name: "Estate",
    subLinks: [{
      href: "/for-sale/estate-personal-property",
      name: "All Estate & Personal Property"
    }, {
      href: "/for-sale/estate-personal-property/clothing-shoes-accessories",
      name: "Clothing, Shoes & Accessories"
    }, {
      href: "/for-sale/estate-personal-property/lamps-lighting-fans",
      name: "Lamps, Lighting & Fans"
    }, {
      href: "/for-sale/estate-personal-property/personal-property",
      name: "Personal Property"
    }, {
      href: "/for-sale/estate-personal-property/sporting-goods",
      name: "Sporting Goods"
    }, {
      href: "/for-sale/estate-personal-property/used-books-magazines",
      name: "Used Books & Magazines"
    }, {
      href: "/for-sale/estate-personal-property/yard-garden-garage-equipment",
      name: "Yard, Garden & Garage Equipment"
    }]
  }], [{
    name: "Furniture",
    subLinks: [{
      href: "/for-sale/estate-personal-property/furniture",
      name: "All Furniture"
    }, {
      href: "/for-sale/estate-personal-property/bedroom-furniture",
      name: "Bedroom Furniture"
    }, {
      href: "/for-sale/estate-personal-property/benches-stools-stands",
      name: "Benches, Stools & Stands"
    }, {
      href: "/for-sale/estate-personal-property/cabinets",
      name: "Cabinets"
    }, {
      href: "/for-sale/estate-personal-property/chairs",
      name: "Chairs"
    }, {
      href: "/for-sale/estate-personal-property/sofas-loveseats-chaises",
      name: "Sofas, Loveseats & Chaises"
    }, {
      href: "/for-sale/estate-personal-property/tables",
      name: "Tables"
    }]
  }]]
}, {
  href: "/for-sale/coins-currency",
  name: "Coins",
  subCategories: [[{
    name: "Coins",
    subLinks: [{
      href: "/for-sale/coins-currency/coins",
      name: "All Coins"
    }, {
      href: "/for-sale/coins-currency/ancient-coins",
      name: "Ancient Coins"
    }, {
      href: "/for-sale/coins-currency/coin-collections",
      name: "Coin Collections"
    }, {
      href: "/for-sale/coins-currency/gold-coins",
      name: "Gold Coins"
    }, {
      href: "/for-sale/coins-currency/silver-coins",
      name: "Silver Coins"
    }]
  }, {
    name: "Coins by Origin",
    subLinks: [{
      href: "/for-sale/coins-currency/european-coins",
      name: "European Coins"
    }, {
      href: "/for-sale/coins-currency/north-central-american-coins",
      name: "North & Central American Coins"
    }, {
      href: "/for-sale/coins-currency/us-coins",
      name: "US Coins"
    }, {
      href: "/for-sale/coins-currency/world-coins",
      name: "World Coins"
    }]
  }], [{
    name: "Bullions",
    subLinks: [{
      href: "/for-sale/coins-currency/bullion",
      name: "All Bullion"
    }, {
      href: "/for-sale/coins-currency/gold-bullion",
      name: "Gold Bullion"
    }, {
      href: "/for-sale/coins-currency/platinum-bullion",
      name: "Platinum Bullion"
    }, {
      href: "/for-sale/coins-currency/silver-bullion",
      name: "Silver Bullion"
    }]
  }, {
    name: "Currency",
    subLinks: [{
      href: "/for-sale/coins-currency/currency",
      name: "All Currency"
    }, {
      href: "/for-sale/coins-currency/exonumia",
      name: "Exonumia"
    }]
  }], [{
    name: "Currency by Origin",
    subLinks: [{
      href: "/for-sale/coins-currency/european-currency",
      name: "European Currency"
    }, {
      href: "/for-sale/coins-currency/us-currency",
      name: "U.S. Currency"
    }, {
      href: "/for-sale/coins-currency/world-currency",
      name: "World Currency"
    }]
  }], [{
    name: "Popular Categories",
    subLinks: [{
      href: "/for-sale/coins-currency",
      name: "All Coins & Currency"
    }, {
      href: "/for-sale/coins-currency/dimes",
      name: "Dimes"
    }, {
      href: "/for-sale/coins-currency/half-dollars",
      name: "Half Dollars"
    }, {
      href: "/for-sale/coins-currency/large-cents",
      name: "Large Cents"
    }, {
      href: "/for-sale/coins-currency/nickels",
      name: "Nickels"
    }, {
      href: "/for-sale/coins-currency/quarters",
      name: "Quarters"
    }, {
      href: "/for-sale/coins-currency/small-cents",
      name: "Small Cents"
    }, {
      href: "/for-sale/coins-currency/us-dollar-coins",
      name: "US Dollar Coins"
    }]
  }]]
}, {
  href: "/for-sale/jewelry-gemstones-watches",
  name: "Jewelry",
  subCategories: [[{
    name: "Jewelry",
    subLinks: [{
      href: "/for-sale/jewelry-gemstones-watches/jewelry",
      name: "All Jewelry"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/bracelets",
      name: "Bracelets"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/brooches-pins",
      name: "Brooches & Pins"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/cufflinks",
      name: "Cufflinks"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/earrings",
      name: "Earrings"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/gold-jewelry",
      name: "Gold Jewelry"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/jewelry-sets",
      name: "Jewelry Sets"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/necklaces-pendants",
      name: "Necklaces & Pendants"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/other-jewelry",
      name: "Other Jewelry"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/rings",
      name: "Rings"
    }]
  }], [{
    name: "Watches",
    subLinks: [{
      href: "/for-sale/jewelry-gemstones-watches/watches",
      name: "All Watches"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/diamond-watches",
      name: "Diamond Watches"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/men-s-watches",
      name: "Men's Watches"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/women-s-watches",
      name: "Women's Watches"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/pocket-watches",
      name: "Pocket Watches"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/vintage-watches",
      name: "Vintage Watches"
    }]
  }], [{
    name: "Gemstones",
    subLinks: [{
      href: "/for-sale/jewelry-gemstones-watches/gemstones",
      name: "All Gemstones"
    }]
  }], [{
    name: "Popular Categories",
    subLinks: [{
      href: "/for-sale/jewelry-gemstones-watches",
      name: "All Jewelry, Gemstones & Watches"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/diamond-rings",
      name: "Diamond Rings"
    }, {
      href: "/for-sale/jewelry-gemstones-watches/gold-bracelets",
      name: "Gold Bracelets"
    }]
  }]]
}, {
  href: "/for-sale/guns-military-artifacts",
  name: "Firearms",
  subCategories: [[{
    name: "Firearms",
    subLinks: [{
      href: "/for-sale/guns-military-artifacts",
      name: "All Guns & Military Artifacts"
    }, {
      href: "/for-sale/guns-military-artifacts/ammo",
      name: "Ammo"
    }, {
      href: "/for-sale/guns-military-artifacts/black-powder",
      name: "Black Powder"
    }, {
      href: "/for-sale/guns-military-artifacts/gun-optics-scopes",
      name: "Gun Optics & Scopes"
    }, {
      href: "/for-sale/guns-military-artifacts/gun-parts",
      name: "Gun Parts"
    }, {
      href: "/for-sale/guns-military-artifacts/gun-storage",
      name: "Gun Storage"
    }, {
      href: "/for-sale/guns-military-artifacts/handguns-pistols",
      name: "Handguns & Pistols"
    }, {
      href: "/for-sale/guns-military-artifacts/rifles",
      name: "Rifles"
    }, {
      href: "/for-sale/guns-military-artifacts/recreational-shooting",
      name: "Recreational Shooting"
    }, {
      href: "/for-sale/guns-military-artifacts/reloading-supplies",
      name: "Reloading Supplies"
    }, {
      href: "/for-sale/guns-military-artifacts/shotguns",
      name: "Shotguns"
    }, {
      href: "/for-sale/guns-military-artifacts/shooting-accessories",
      name: "Shooting Accessories"
    }]
  }], [{
    name: "Knives, Blades & Tools",
    subLinks: [{
      href: "/for-sale/guns-military-artifacts/knives-blades-tools",
      name: "All Knives, Blades & Tools"
    }, {
      href: "/for-sale/guns-military-artifacts/bayonets",
      name: "Bayonets"
    }, {
      href: "/for-sale/guns-military-artifacts/knives",
      name: "Knives"
    }, {
      href: "/for-sale/guns-military-artifacts/swords",
      name: "Swords"
    }]
  }], [{
    name: "Militaria",
    subLinks: [{
      href: "/for-sale/guns-military-artifacts/militaria",
      name: "All Militaria"
    }, {
      href: "/for-sale/guns-military-artifacts/civil-war-relics",
      name: "Civil War Relics"
    }, {
      href: "/for-sale/guns-military-artifacts/ww1-ww2-memorabilia",
      name: "WW1 & WW2 Memorabilia"
    }]
  }], [{
    name: "Popular Categories",
    subLinks: [{
      href: "/for-sale/guns-military-artifacts/lever-action-rifles",
      name: "Lever Action Rifles"
    }, {
      href: "/for-sale/guns-military-artifacts/military-surplus",
      name: "Military Surplus"
    }, {
      href: "/for-sale/guns-military-artifacts/revolvers",
      name: "Revolvers"
    }, {
      href: "/for-sale/guns-military-artifacts/scopes",
      name: "Scopes"
    }]
  }]]
}, {
  href: "/for-sale/art-antiques-collectibles",
  name: "Art & Antiques",
  subCategories: [[{
    name: "Antiques",
    subLinks: [{
      href: "/for-sale/art-antiques-collectibles/antiques",
      name: "All Antiques"
    }, {
      href: "/for-sale/art-antiques-collectibles/asian-antiques",
      name: "Asian Antiques"
    }, {
      href: "/for-sale/art-antiques-collectibles/antique-clocks",
      name: "Antique Clocks"
    }, {
      href: "/for-sale/art-antiques-collectibles/antique-vintage-furniture",
      name: "Antique & Vintage Furniture"
    }, {
      href: "/for-sale/art-antiques-collectibles/antique-lamps",
      name: "Antique Lamps"
    }, {
      href: "/for-sale/art-antiques-collectibles/antique-primitives",
      name: "Antique Primitives"
    }, {
      href: "/for-sale/art-antiques-collectibles/antique-tools",
      name: "Antique Tools"
    }]
  }], [{
    name: "Collectibles",
    subLinks: [{
      href: "/for-sale/art-antiques-collectibles/collectibles",
      name: "All Collectibles"
    }, {
      href: "/for-sale/art-antiques-collectibles/collectible-advertising",
      name: "Collectible Advertising"
    }, {
      href: "/for-sale/art-antiques-collectibles/collectible-books",
      name: "Collectible Books"
    }, {
      href: "/for-sale/art-antiques-collectibles/collectible-linens-textiles",
      name: "Collectible Linens & Textiles"
    }, {
      href: "/for-sale/art-antiques-collectibles/decorative-collectibles",
      name: "Decorative Collectibles"
    }, {
      href: "/for-sale/art-antiques-collectibles/entertainment-memorabilia",
      name: "Entertainment Memorabilia"
    }, {
      href: "/for-sale/art-antiques-collectibles/historical-collectibles",
      name: "Historical Collectibles"
    }, {
      href: "/for-sale/art-antiques-collectibles/sports-memorabilia",
      name: "Sports Memorabilia"
    }, {
      href: "/for-sale/art-antiques-collectibles/transportation-collectibles",
      name: "Transportation Collectibles"
    }, {
      href: "/for-sale/art-antiques-collectibles/vintage-arcade-coin-op-machines",
      name: "Vintage Arcade & Coin-Op Machines"
    }]
  }], [{
    name: "Art",
    subLinks: [{
      href: "/for-sale/art-antiques-collectibles/art",
      name: "All Art"
    }, {
      href: "/for-sale/art-antiques-collectibles/fine-art-photography",
      name: "Fine Art Photography"
    }, {
      href: "/for-sale/art-antiques-collectibles/lithographs-serigraphs",
      name: "Lithographs & Serigraphs"
    }, {
      href: "/for-sale/art-antiques-collectibles/paintings",
      name: "Paintings"
    }, {
      href: "/for-sale/art-antiques-collectibles/prints-posters",
      name: "Prints & Posters"
    }, {
      href: "/for-sale/art-antiques-collectibles/sculptures",
      name: "Sculptures"
    }, {
      href: "/for-sale/art-antiques-collectibles/statues",
      name: "Statues"
    }]
  }], [{
    name: "Popular Categories",
    subLinks: [{
      href: "/for-sale/art-antiques-collectibles",
      name: "All Art, Antiques & Collectibles"
    }, {
      href: "/for-sale/art-antiques-collectibles/art-prints",
      name: "Art Prints"
    }, {
      href: "/for-sale/art-antiques-collectibles/artifacts-archaeology",
      name: "Artifacts & Archeology"
    }, {
      href: "/for-sale/art-antiques-collectibles/glass-pottery",
      name: "Glass & Pottery"
    }, {
      href: "/for-sale/art-antiques-collectibles/oil-paintings",
      name: "Oil Paintings"
    }, {
      href: "/for-sale/art-antiques-collectibles/movie-memorabilia",
      name: "Movie Memorabilia"
    }, {
      href: "/for-sale/art-antiques-collectibles/movie-posters",
      name: "Movie Posters"
    }, {
      href: "/for-sale/art-antiques-collectibles/music-memorabilia",
      name: "Music Memorabilia"
    }, {
      href: "/for-sale/art-antiques-collectibles/silverware",
      name: "Silverware"
    }, {
      href: "/for-sale/art-antiques-collectibles/sports-cards",
      name: "Sports Cards"
    }, {
      href: "/for-sale/art-antiques-collectibles/toys",
      name: "Toys"
    }]
  }]]
}, {
  href: "/all-categories",
  name: "Other",
  subCategories: [[{
    name: "Horse & Livestock",
    subLinks: [{
      href: "/for-sale/horse-livestock",
      name: "All Horse & Livestock"
    }, {
      href: "/for-sale/horse-livestock/horse-stock-trailers",
      name: "Horse & Stock Trailers"
    }, {
      href: "/for-sale/horse-livestock/horse-tack",
      name: "Horse Tack"
    }, {
      href: "/for-sale/horse-livestock/horse-trailers",
      name: "Horse Trailers"
    }, {
      href: "/for-sale/horse-livestock/livestock",
      name: "Livestock"
    }, {
      href: "/for-sale/horse-livestock/livestock-equipment",
      name: "Livestock Equipment"
    }, {
      href: "/for-sale/horse-livestock/livestock-trailers",
      name: "Livestock Trailers"
    }]
  }], [{
    name: "Real Estate",
    subLinks: [{
      href: "/for-sale/real-estate",
      name: "All Real Estate"
    }, {
      href: "/for-sale/real-estate/land",
      name: "Land"
    }, {
      href: "/for-sale/real-estate/commercial-real-estate",
      name: "Commercial Real Estate"
    }, {
      href: "/for-sale/real-estate/homes",
      name: "Homes"
    }]
  }], [{
    name: "Computer & Electronics",
    subLinks: [{
      href: "/for-sale/computers-electronics",
      name: "All Computers & Electronics"
    }, {
      href: "/for-sale/computers-electronics/appliances",
      name: "Appliances"
    }, {
      href: "/for-sale/computers-electronics/computers",
      name: "Computers"
    }, {
      href: "/for-sale/computers-electronics/electronics",
      name: "Electronics"
    }]
  }], [{
    name: "Benefit & Charity",
    subLinks: [{
      href: "/for-sale/benefit-charity",
      name: "All Benefit & Charity Auctions"
    }]
  }, {
    href: "/all-categories",
    name: "All Categories",
    subLinks: [{
      href: "/all-categories",
      name: "View All Categories"
    }]
  }]]
}];

var _text = require('@liveauctioneers/hammer-ui-core/text');

var _providers = require('@liveauctioneers/hammer-ui-core/providers');

var _link = require('@liveauctioneers/hammer-ui-core/link');

var _react = require('react');

var _styledcomponents = require('styled-components');

var _styledcomponents2 = _interopRequireDefault(_styledcomponents);

var _jsxruntime = require('react/jsx-runtime');

var me = function me(_ref) {
  var e = _ref.categoryName,
      o = _ref.onMouseLeave,
      n = _ref.subCategories;

  var a = _react.useRef.call(void 0, null),
      t = _providers.usePreventDefaultLinkOnClick.call(void 0);

  return _jsxruntime.jsx.call(void 0, je, {
    "data-navid": e,
    onMouseLeave: o,
    children: _jsxruntime.jsx.call(void 0, ze, {
      ref: a,
      children: n.map(function (r, c) {
        return _jsxruntime.jsx.call(void 0, _e, {
          children: r.map(function (s) {
            return _jsxruntime.jsxs.call(void 0, Ze, {
              children: [_jsxruntime.jsx.call(void 0, _text.H5, {
                as: "h3",
                children: s.name
              }), s.subLinks.map(function (m) {
                return _jsxruntime.jsx.call(void 0, _text.BodyPrimary, {
                  as: "h4",
                  children: _jsxruntime.jsx.call(void 0, Je, {
                    href: m.href,
                    onClick: t(m.href),
                    children: m.name
                  })
                }, m.name);
              })]
            }, s.name);
          })
        }, c);
      })
    })
  });
},
    je = _styledcomponents2.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: absolute;\n    overflow: hidden;\n    width: 0;\n    height: 0;\n"]))),
    ze = _styledcomponents2.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    max-width: ", ";\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-template-rows: 1fr;\n    gap: 24px;\n    padding: 32px 24px 32px 24px;\n    margin: 0 auto;\n"])), function (_ref2) {
  var e = _ref2.theme;
  return e.breakpoints.xlMin;
}),
    Ze = _styledcomponents2.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: column;\n    :not(:first-child) {\n        margin-top: 48px;\n    }\n"]))),
    Je = _styledcomponents2.default.call(void 0, _link.SubtleWeakLink)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    width: fit-content;\n    margin: 16px 0 0 0;\n"]))),
    _e = _styledcomponents2.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: column;\n"])));

var nr = [B.name, D.name, b.name],
    fe = function fe(_ref3) {
  var e = _ref3.currentHeaderGroup,
      o = _ref3.setCurrentHeaderGroup;

  var _react$useState$call = _react.useState.call(void 0, !1),
      _react$useState$call2 = _slicedToArray(_react$useState$call, 2),
      n = _react$useState$call2[0],
      a = _react$useState$call2[1],
      t = _react.useRef.call(void 0, void 0),
      r = function r(i) {
    t.current = setTimeout(function () {
      a(!1), o(i), window.addEventListener("scroll", l);
    }, 300);
  },
      c = function c() {
    t.current && clearTimeout(t.current), nr.includes(e) || o(""), window.removeEventListener("scroll", l);
  },
      s = _providers.useOnLinkClick.call(void 0),
      m = function m(i) {
    s(i), c();
  },
      l = function l() {
    a(!0);
  };

  return _react.useEffect.call(void 0, function () {
    return function () {
      window.removeEventListener("scroll", l);
    };
  }, []), _jsxruntime.jsx.call(void 0, sr, {
    $currentHeaderGroup: e,
    "aria-label": "Category Navigation",
    onMouseLeave: c,
    children: E.map(function (i) {
      return _jsxruntime.jsxs.call(void 0, tr, {
        $isActive: i.name === e,
        children: [_jsxruntime.jsx.call(void 0, lr, {
          href: i.href,
          onClick: function onClick(f) {
            f.preventDefault(), i.href && m(_nullishCoalesce(i.href, function () {
              return "";
            }));
          },
          onMouseEnter: function onMouseEnter() {
            return r(i.name);
          },
          children: _jsxruntime.jsx.call(void 0, ir, {
            color: "inverse",
            children: i.name
          })
        }), _jsxruntime.jsx.call(void 0, _providers.LinkProvider, {
          onLinkClick: m,
          children: _jsxruntime.jsx.call(void 0, me, {
            categoryName: i.name,
            onMouseLeave: c,
            subCategories: i.subCategories
          })
        }), !n && _jsxruntime.jsx.call(void 0, cr, {
          className: "backdrop"
        })]
      }, i.name);
    })
  });
},
    tr = _styledcomponents2.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    border-bottom: 4px solid transparent;\n    border-bottom-color: ", ";\n    height: 100%;\n    display: flex;\n    flex-flow: column;\n    justify-content: center;\n"])), function (_ref4) {
  var e = _ref4.$isActive,
      o = _ref4.theme;
  return e && o.color.border.divider.inverse;
}),
    sr = _styledcomponents2.default.nav(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    color: white;\n    z-index: 10;\n\n    :hover {\n        ", "\n    }\n"])), function (_ref5) {
  var e = _ref5.$currentHeaderGroup;
  return e !== "" && _styledcomponents.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n                [data-navid='", "'] {\n                    width: 100%;\n                    height: auto;\n                    overflow: auto;\n                    background: white;\n                    top: 100%;\n                    left: 0;\n                    right: 0;\n                    z-index: 1;\n                    box-shadow: ", ";\n\n                    + div.backdrop {\n                        display: block;\n                    }\n                }\n            "])), e, function (_ref6) {
    var o = _ref6.theme;
    return o.elevation["03"];
  });
}),
    ir = _styledcomponents2.default.call(void 0, _text.BodySecondary)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    cursor: pointer;\n    user-select: none;\n"]))),
    lr = _styledcomponents2.default.a(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    color: transparent;\n"]))),
    cr = _styledcomponents2.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    display: none;\n    background: black;\n    height: calc(100% - 124px);\n    width: 100%;\n    position: fixed;\n    left: 0;\n    top: 124px;\n    opacity: 0.1;\n"])));

var _button = require('@liveauctioneers/hammer-ui-core/button');

var _searchInput = require('@liveauctioneers/hammer-ui-core/searchInput');

var _usedebounce = require('use-debounce');

var j = function j(_ref7) {
  var e = _ref7.currentHeaderGroup,
      o = _ref7.onHeaderSearch,
      n = _ref7.onHeaderSearchSubmitted,
      a = _ref7.onShowSearch,
      t = _ref7.searchSuggestions,
      r = _ref7.setShowSearch,
      c = _ref7.showSearch;

  var s = _react.useRef.call(void 0, null),
      m = _providers.useOnLinkClick.call(void 0),
      l = _usedebounce.useThrottledCallback.call(void 0, function (f) {
    o(f);
  }, 500, {
    leading: !1,
    trailing: !0
  });

  _react.useEffect.call(void 0, function () {
    e && r(!1);
  }, [e, r]);

  var i = function i(f) {
    f.length && (n(f), r(!1));
  };

  return _jsxruntime.jsxs.call(void 0, yr, {
    onBlur: function onBlur(f) {
      _optionalChain([s, 'access', function (_2) {
        return _2.current;
      }, 'optionalAccess', function (_3) {
        return _3.contains;
      }, 'call', function (_4) {
        return _4(f.relatedTarget);
      }]) || r(!1);
    },
    onFocus: a,
    ref: s,
    children: [_jsxruntime.jsx.call(void 0, kr, {
      "aria-label": "Search",
      onSubmit: i,
      onTextChange: l,
      placeholder: "Search items, auction events, or auction houses"
    }), _jsxruntime.jsx.call(void 0, br, {
      "aria-label": "Search",
      onSubmit: i,
      onTextChange: l,
      placeholder: "Search Proxibid"
    }), t && t.length > 0 && c && !e && _jsxruntime.jsx.call(void 0, vr, {
      children: t.map(function (f) {
        return _jsxruntime.jsx.call(void 0, Sr, {
          forwardedAs: "li",
          children: _jsxruntime.jsxs.call(void 0, _link.SubtleMonochromeLink, {
            href: f.href,
            onClick: function onClick(d) {
              d.preventDefault(), m(f.href), r(!1);
            },
            onFocus: function onFocus(d) {
              return d.stopPropagation();
            },
            children: ["in ", f.name, " (", f.count, ")"]
          })
        }, f.name);
      })
    })]
  });
},
    yr = _styledcomponents2.default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    width: 100%;\n    position: relative;\n\n    max-width: 466px;\n\n    @media (max-width: ", "px) {\n        max-width: 100%;\n    }\n"])), 1103),
    kr = _styledcomponents2.default.call(void 0, _searchInput.SearchInput)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    width: 100%;\n    @media (max-width: 1200px) {\n        display: none;\n    }\n"]))),
    br = _styledcomponents2.default.call(void 0, _searchInput.SearchInput)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    width: 100%;\n    @media (min-width: 1201px) {\n        display: none;\n    }\n"]))),
    vr = _styledcomponents2.default.ul(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    position: absolute;\n    padding: 0 ", " ", ";\n    margin: 0;\n    left: 1px;\n    right: 1px;\n    box-shadow: ", ";\n    background-color: ", ";\n    list-style: none;\n    z-index: 12;\n"])), function (_ref8) {
  var e = _ref8.theme;
  return e.spacing.sm;
}, function (_ref9) {
  var e = _ref9.theme;
  return e.spacing.xs;
}, function (_ref10) {
  var e = _ref10.theme;
  return e.elevation["01"];
}, function (_ref11) {
  var e = _ref11.theme;
  return e.color.background.primary;
}),
    Sr = _styledcomponents2.default.call(void 0, _text.BodyPrimary)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    padding-top: ", ";\n"])), function (_ref12) {
  var e = _ref12.theme;
  return e.spacing.xs;
});

var _heartIcon = require('@liveauctioneers/hammer-ui-core/icons/heartIcon');

var _menuHamburgerIcon = require('@liveauctioneers/hammer-ui-core/icons/menuHamburgerIcon');

var _chevronRightIcon = require('@liveauctioneers/hammer-ui-core/icons/chevronRightIcon');

var P = function P(_ref13) {
  var e = _ref13.categoryLinks,
      o = _ref13.className,
      n = _ref13.onCategoryClicked,
      a = _ref13.subCategory;

  var t = _providers.usePreventDefaultLinkOnClick.call(void 0);

  return e ? _jsxruntime.jsxs.call(void 0, ye, {
    className: o,
    children: [_jsxruntime.jsx.call(void 0, ge, {
      children: _jsxruntime.jsx.call(void 0, _text.H5, {
        children: "Categories"
      })
    }), e.map(function (r) {
      return _jsxruntime.jsxs.call(void 0, Lr, {
        onClick: function onClick() {
          return _optionalChain([n, 'optionalCall', function (_5) {
            return _5(r);
          }]);
        },
        children: [_jsxruntime.jsx.call(void 0, _link.SubtleMonochromeLink, {
          size: "md",
          children: r.name
        }), _jsxruntime.jsx.call(void 0, _chevronRightIcon.ChevronRightIconSmall, {
          color: "default"
        })]
      }, "".concat(r.name, "-category"));
    })]
  }) : a ? _jsxruntime.jsxs.call(void 0, ye, {
    className: o,
    children: [_jsxruntime.jsx.call(void 0, ge, {
      children: _jsxruntime.jsx.call(void 0, _text.H5, {
        children: a.name
      })
    }), a.subLinks.map(function (r) {
      return _jsxruntime.jsx.call(void 0, xr, {
        href: r.href,
        onClick: t(r.href),
        size: "md",
        children: r.name
      }, r.name);
    })]
  }) : null;
},
    ge = _styledcomponents2.default.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    padding: 16px 0;\n"]))),
    Lr = _styledcomponents2.default.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 0 12px 24px;\n    cursor: pointer;\n\n    &:hover {\n        text-decoration: underline;\n    }\n"]))),
    xr = _styledcomponents2.default.call(void 0, _link.SubtleMonochromeLink)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    padding: 12px 0 12px 24px;\n"]))),
    ye = _styledcomponents2.default.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: column;\n"])));

var be = function be(_ref14) {
  var e = _ref14.category,
      o = _ref14.className,
      n = _ref14.onSubCategoryClicked;

  var a = _providers.useOnLinkClick.call(void 0),
      t = _react.useMemo.call(void 0, function () {
    var r = [];
    return e.subCategories.forEach(function (c) {
      return c.forEach(function (s) {
        return r.push(s);
      });
    }), r;
  }, [e.subCategories]);

  return t.length < 3 ? _jsxruntime.jsx.call(void 0, "div", {
    className: o,
    children: t.map(function (r) {
      return _jsxruntime.jsx.call(void 0, P, {
        subCategory: r
      }, r.name);
    })
  }) : _jsxruntime.jsx.call(void 0, "div", {
    className: o,
    children: t.map(function (r) {
      return _jsxruntime.jsxs.call(void 0, Tr, {
        onClick: function onClick() {
          r.href ? a(r.href) : n(r);
        },
        children: [_jsxruntime.jsx.call(void 0, _link.SubtleMonochromeLink, {
          size: "md",
          children: r.name
        }), !r.href && _jsxruntime.jsx.call(void 0, _chevronRightIcon.ChevronRightIconSmall, {
          color: "default"
        })]
      }, r.name);
    })
  });
},
    Tr = _styledcomponents2.default.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 0;\n    cursor: pointer;\n\n    &:hover {\n        text-decoration: underline;\n    }\n"])));

var _arrowLeftIcon = require('@liveauctioneers/hammer-ui-core/icons/arrowLeftIcon');

var _closeIcon = require('@liveauctioneers/hammer-ui-core/icons/closeIcon');

var Se = function Se(_ref15) {
  var e = _ref15.currentCategory,
      o = _ref15.currentSubCategory,
      n = _ref15.isProfile,
      a = _ref15.onBackClicked,
      t = _ref15.onCloseClicked;
  var r = "Menu";
  return n ? r = "" : o ? r = o.name : e && (r = e.name), _jsxruntime.jsxs.call(void 0, $r, {
    children: [!!_nullishCoalesce(o, function () {
      return e;
    }) && _jsxruntime.jsx.call(void 0, ve, {
      $isCloseIcon: !1,
      children: _jsxruntime.jsx.call(void 0, _arrowLeftIcon.ArrowLeftIconMedium, {
        color: "default",
        cursor: "pointer",
        onClick: a
      })
    }), _jsxruntime.jsx.call(void 0, Nr, {
      children: _jsxruntime.jsx.call(void 0, _text.H1, {
        "aria-label": "Menu Title",
        as: "span",
        forceMobile: !0,
        children: r
      })
    }), _jsxruntime.jsx.call(void 0, ve, {
      $isCloseIcon: !0,
      children: _jsxruntime.jsx.call(void 0, _closeIcon.CloseIconMedium, {
        color: "default",
        cursor: "pointer",
        onClick: t
      })
    })]
  });
},
    $r = _styledcomponents2.default.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    display: grid;\n    align-items: center;\n    justify-content: flex-start;\n    grid-template-columns: 30px 1fr 30px;\n    grid-template-areas: 'back title close';\n    margin-bottom: 16px;\n"]))),
    Nr = _styledcomponents2.default.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n    grid-area: title;\n    text-align: center;\n"]))),
    ve = _styledcomponents2.default.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: flex-start;\n    height: 100%;\n    margin-top: 6px;\n    grid-area: ", ";\n"])), function (_ref16) {
  var e = _ref16.$isCloseIcon;
  return e ? "close" : "back";
});

var we = [b.subLinks[0], S],
    Ce = [{
  href: "/asp/Bidder/PrebidManage.asp",
  name: "Buying"
}, {
  href: "/asp/Bidder/PrebidManage.asp?opt=2",
  name: "Purchased"
}, {
  href: "/asp/Bidder/InvoiceManage.asp",
  name: "Invoices"
}];

var qe = function qe(_ref17) {
  var e = _ref17.className,
      o = _ref17.userData;

  var n = o.email,
      a = o.name,
      t = _providers.usePreventDefaultLinkOnClick.call(void 0);

  return _jsxruntime.jsxs.call(void 0, Vr, {
    className: e,
    children: [_jsxruntime.jsxs.call(void 0, Ur, {
      children: [_jsxruntime.jsxs.call(void 0, jr, {
        forwardedAs: "span",
        children: ["Hi, ", a]
      }), _jsxruntime.jsx.call(void 0, zr, {
        color: "weak",
        children: n
      })]
    }), _jsxruntime.jsx.call(void 0, xe, {
      children: we.map(function (r) {
        return _jsxruntime.jsx.call(void 0, Le, {
          href: r.href,
          onClick: t(r.href),
          children: r.name
        }, r.href);
      })
    }), _jsxruntime.jsx.call(void 0, Zr, {}), _jsxruntime.jsx.call(void 0, xe, {
      children: Ce.map(function (r) {
        return _jsxruntime.jsx.call(void 0, Le, {
          "data-testid": r.name === "Buying" ? "pick" : "asdfk",
          href: r.href,
          onClick: t(r.href),
          children: r.name
        }, r.href);
      })
    })]
  });
},
    Vr = _styledcomponents2.default.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: column;\n"]))),
    Ur = _styledcomponents2.default.div(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n    padding: 16px 8px;\n    background: ", ";\n    display: flex;\n    flex-flow: column;\n    margin-bottom: 24px;\n"])), function (_ref18) {
  var e = _ref18.theme;
  return e.color.background.secondary;
}),
    jr = _styledcomponents2.default.call(void 0, _text.H1)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n    && {\n        -webkit-line-clamp: 1;\n        overflow: hidden;\n        white-space: normal;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n    }\n"]))),
    zr = _styledcomponents2.default.call(void 0, _text.BodyPrimary)(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n    overflow: hidden;\n    text-transform: uppercase;\n"]))),
    Le = _styledcomponents2.default.call(void 0, _link.SubtleMonochromeLink)(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n    display: flex;\n    padding: 12px 0;\n"]))),
    xe = _styledcomponents2.default.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n    margin-left: 24px;\n"]))),
    Zr = _styledcomponents2.default.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n    margin: 16px 0;\n    border: 1px solid ", ";\n"])), function (_ref19) {
  var e = _ref19.theme;
  return e.color.border.divider.default;
});

var Me = function Me(_ref20) {
  var e = _ref20.className,
      o = _ref20.subCategory;

  var n = _providers.usePreventDefaultLinkOnClick.call(void 0);

  return _jsxruntime.jsx.call(void 0, Kr, {
    className: e,
    children: o.subLinks.map(function (a) {
      return _jsxruntime.jsx.call(void 0, Qr, {
        href: a.href,
        onClick: n(a.href),
        size: "md",
        children: a.name
      }, a.name);
    })
  });
},
    Kr = _styledcomponents2.default.div(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: column;\n"]))),
    Qr = _styledcomponents2.default.call(void 0, _link.SubtleMonochromeLink)(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n    padding: 12px 0;\n"])));

var Ae = function Ae(_ref21) {
  var e = _ref21.isProfile,
      o = _ref21.isSignedIn,
      n = _ref21.setShowDropdown,
      a = _ref21.showDropdown,
      t = _ref21.userData;

  var _react$useState$call3 = _react.useState.call(void 0, !1),
      _react$useState$call4 = _slicedToArray(_react$useState$call3, 2),
      r = _react$useState$call4[0],
      c = _react$useState$call4[1],
      _react$useState$call5 = _react.useState.call(void 0, null),
      _react$useState$call6 = _slicedToArray(_react$useState$call5, 2),
      s = _react$useState$call6[0],
      m = _react$useState$call6[1],
      _react$useState$call7 = _react.useState.call(void 0, null),
      _react$useState$call8 = _slicedToArray(_react$useState$call7, 2),
      l = _react$useState$call8[0],
      i = _react$useState$call8[1],
      f = function f() {
    l ? i(null) : m(null);
  },
      d = function d() {
    n(!1);
  };

  _react.useEffect.call(void 0, function () {
    a ? (m(null), i(null), c(a)) : setTimeout(function () {
      c(a);
    }, 150);
  }, [a]);

  var k = function k(u) {
    m(u);
  },
      F = function F(u) {
    i(u);
  },
      re = _providers.useOnLinkClick.call(void 0),
      O = function O(u) {
    re(u), n(!1);
  },
      V = _jsxruntime.jsxs.call(void 0, _providers.LinkProvider, {
    onLinkClick: O,
    children: [_jsxruntime.jsxs.call(void 0, mo, {
      $show: !l && !s && !e,
      children: [_jsxruntime.jsx.call(void 0, P, {
        categoryLinks: E,
        onCategoryClicked: k
      }), _jsxruntime.jsx.call(void 0, ie, {}), _jsxruntime.jsx.call(void 0, P, {
        subCategory: B
      }), _jsxruntime.jsx.call(void 0, ie, {}), _jsxruntime.jsx.call(void 0, P, {
        subCategory: D
      }), _jsxruntime.jsx.call(void 0, ie, {}), o && _jsxruntime.jsx.call(void 0, co, {
        onClick: function onClick() {
          return O(b.subLinks[1].href);
        },
        variant: "secondary",
        children: b.subLinks[1].name
      })]
    }), E.map(function (u) {
      return _jsxruntime.jsxs.call(void 0, "div", {
        children: [_jsxruntime.jsx.call(void 0, fo, {
          $show: !!(s && !l && s.name === u.name),
          category: _optionalChain([s, 'optionalAccess', function (_6) {
            return _6.name;
          }]) === u.name ? s : u,
          onSubCategoryClicked: F
        }), s && l && u.subCategories.map(function (v) {
          return v.map(function (C) {
            return _jsxruntime.jsx.call(void 0, uo, {
              $show: C.name === l.name && s.name === u.name,
              subCategory: C.name === l.name ? l : C
            }, "".concat(C.href, "-").concat(C.name));
          });
        })]
      }, "".concat(u.name, "-").concat(u.href));
    })]
  });

  return _jsxruntime.jsxs.call(void 0, so, {
    $renderDropdown: r,
    "aria-label": "Mobile Navigation",
    children: [_jsxruntime.jsx.call(void 0, io, {
      $showTransition: a,
      onClick: function onClick() {
        return n(!1);
      }
    }), _jsxruntime.jsxs.call(void 0, lo, {
      $showTransition: a,
      children: [_jsxruntime.jsx.call(void 0, Se, {
        currentCategory: s,
        currentSubCategory: l,
        isProfile: e,
        onBackClicked: f,
        onCloseClicked: d
      }), e && _jsxruntime.jsx.call(void 0, qe, {
        userData: t
      }), V]
    })]
  });
},
    oo = _styledcomponents.keyframes(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n    0% {\n      opacity: 0;\n      visibility: hidden;\n    }\n    100% {\n      opacity: .1;\n      visibility: visible;\n    }\n  "]))),
    ao = _styledcomponents.keyframes(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n    0% {\n      opacity: .1;\n      visibility: visible;\n    }\n    100% {\n      opacity: 0;\n      visibility: hidden;\n    }\n  "]))),
    no = _styledcomponents.keyframes(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n    0% {\n      left: -400px\n    }\n    100% {\n        left: 0\n    }\n  "]))),
    to = _styledcomponents.keyframes(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n    0% {\n      left: 0\n    }\n    100% {\n        left: -400px\n    }\n  "]))),
    so = _styledcomponents2.default.nav(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    left: 0;\n    top: 0;\n    margin-top: 68.5px;\n    z-index: 15;\n\n    ", "\n"])), function (_ref22) {
  var e = _ref22.$renderDropdown;
  return !e && _styledcomponents.css(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n            height: 0;\n            width: 0;\n            overflow: hidden;\n        "])));
}),
    io = _styledcomponents2.default.div(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n    height: 100%;\n    width: 100%;\n    background: black;\n    position: absolute;\n    opacity: 0.1;\n    animation-duration: 0.2s;\n    animation-name: ", ";\n"])), function (_ref23) {
  var e = _ref23.$showTransition;
  return e ? oo : ao;
}),
    lo = _styledcomponents2.default.div(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n    overflow-y: auto;\n    background: white;\n    width: 384px;\n    height: calc(100% - 68.5px);\n    padding: 24px 16px;\n    padding-bottom: 32px;\n    position: absolute;\n    animation-duration: 0.2s;\n    animation-name: ", ";\n\n    @media (max-width: 384px) {\n        width: 100%;\n    }\n"])), function (_ref24) {
  var e = _ref24.$showTransition;
  return e ? no : to;
}),
    ie = _styledcomponents2.default.div(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n    margin: 16px 0;\n    border: 1px solid ", ";\n"])), function (_ref25) {
  var e = _ref25.theme;
  return e.color.border.divider.default;
}),
    co = _styledcomponents2.default.call(void 0, _button.Button)(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n    width: 100%;\n"]))),
    mo = _styledcomponents2.default.div(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n    ", "\n"])), function (_ref26) {
  var e = _ref26.$show;
  return !e && _styledcomponents.css(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n            height: 0;\n            width: 0;\n            overflow: hidden;\n        "])));
}),
    fo = _styledcomponents2.default.call(void 0, be)(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n    ", "\n"])), function (_ref27) {
  var e = _ref27.$show;
  return !e && _styledcomponents.css(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n            height: 0;\n            width: 0;\n            overflow: hidden;\n        "])));
}),
    uo = _styledcomponents2.default.call(void 0, Me)(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n    ", "\n"])), function (_ref28) {
  var e = _ref28.$show;
  return !e && _styledcomponents.css(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n            height: 0;\n            width: 0;\n            overflow: hidden;\n        "])));
});

var Te = "/",
    _ = function _() {
  var e = _providers.usePreventDefaultLinkOnClick.call(void 0);

  return _jsxruntime.jsx.call(void 0, go, {
    "aria-label": "Home Logo",
    href: Te,
    onClick: e(Te),
    children: _jsxruntime.jsxs.call(void 0, "svg", {
      fill: "#fff",
      height: "28.79",
      id: "Layer_1",
      viewBox: "0 0 1920 531.45",
      width: "104",
      xmlns: "http://www.w3.org/2000/svg",
      children: [_jsxruntime.jsx.call(void 0, "path", {
        className: "cls-1",
        d: "M139.79,106.3H0v425.15H50.32v-106.24h89.47c86.86,0,123.93-48.04,123.93-160.64,0-54.05-8.11-90.93-25.53-116.1-19.64-28.37-51.82-42.16-98.39-42.16Zm-8.89,274.14H50.32V151.06h80.58c66.33,0,78.9,39.89,78.9,113.51s-12.91,115.88-78.9,115.88Z"
      }), _jsxruntime.jsx.call(void 0, "path", {
        className: "cls-1",
        d: "M320.44,221.74v203.46h50.32V234.23c0-58.74,20.5-83.8,68.56-83.8l4.46-44.13h-12.83c-74.36,0-110.51,37.76-110.51,115.44Z"
      }), _jsxruntime.jsx.call(void 0, "path", {
        className: "cls-1",
        d: "M624.43,102.89c-111.35,0-154.73,45.33-154.73,161.67,0,60.84,11.74,101.26,36.94,127.21,24.42,25.13,61.85,36.84,117.79,36.84s93.38-11.71,117.79-36.84c25.21-25.95,36.95-66.37,36.95-127.21,0-116.34-43.39-161.67-154.74-161.67Zm0,281.63c-75.13,0-101.75-31.39-101.75-119.96s25.68-117.58,101.75-117.58,101.76,29.67,101.76,117.58-26.63,119.96-101.76,119.96Z"
      }), _jsxruntime.jsx.call(void 0, "rect", {
        className: "cls-1",
        height: "318.9",
        width: "50.32",
        x: "1112.28",
        y: "106.3"
      }), _jsxruntime.jsx.call(void 0, "rect", {
        className: "cls-1",
        height: "318.9",
        width: "50.32",
        x: "1549.24",
        y: "106.3"
      }), _jsxruntime.jsx.call(void 0, "rect", {
        className: "cls-1",
        height: "53.15",
        width: "50.32",
        x: "1112.27"
      }), _jsxruntime.jsx.call(void 0, "rect", {
        className: "cls-1",
        height: "53.15",
        width: "50.32",
        x: "1549.24"
      }), _jsxruntime.jsx.call(void 0, "path", {
        className: "cls-1",
        d: "M1869.68,0V106.3h-89.47c-86.86,0-123.93,48.04-123.93,160.64,0,54.05,8.11,90.94,25.53,116.09,19.64,28.38,51.82,42.17,98.39,42.17h139.79V0h-50.32Zm0,380.44h-80.58c-66.33,0-78.9-39.89-78.9-113.51s12.91-115.88,78.9-115.88h80.58v229.39Z"
      }), _jsxruntime.jsx.call(void 0, "path", {
        className: "cls-1",
        d: "M1369.05,106.3h-89.94V0h-50.32V425.2h140.25c46.57,0,78.75-13.79,98.39-42.17,17.42-25.16,25.53-62.05,25.53-116.09,0-112.6-37.06-160.64-123.93-160.64Zm-9.36,274.14h-80.58V151.06h80.58c65.99,0,78.9,42.48,78.9,115.88s-12.57,113.51-78.9,113.51Z"
      }), _jsxruntime.jsx.call(void 0, "polygon", {
        className: "cls-1",
        points: "958.74 181.34 989.07 223.54 989.07 223.55 1073.31 106.3 1012.66 106.3 958.74 181.34"
      }), _jsxruntime.jsx.call(void 0, "polygon", {
        className: "cls-1",
        points: "1072.3 423.79 989.16 307.96 989.12 308.02 989.07 307.96 989.07 307.96 958.74 350.17 1012.66 425.2 1012.66 425.2 1012.66 425.2 1073.31 425.2 1073.31 425.2 1073.31 425.2 1072.3 423.79"
      }), _jsxruntime.jsx.call(void 0, "path", {
        className: "cls-1",
        d: "M928.42,223.54l-84.24-117.24h-60.66l114.57,159.45-114.57,159.45h60.66l84.24-117.24h0s30.32-42.21,30.32-42.21l-30.33-42.21h0Zm12.12,16.87l-45.78-63.72,33.66,46.85,12.12,16.87Z"
      })]
    })
  });
},
    go = _styledcomponents2.default.a(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n"])));

var _userProfileIcon = require('@liveauctioneers/hammer-ui-core/icons/userProfileIcon');

var Be = function Be(_ref29) {
  var e = _ref29.currentHeaderGroup,
      o = _ref29.isSignedIn,
      n = _ref29.onHeaderSearch,
      a = _ref29.onHeaderSearchSubmitted,
      t = _ref29.onSetBodyHidden,
      r = _ref29.onSignInClicked,
      c = _ref29.searchSuggestions,
      s = _ref29.userData;

  var _react$useState$call9 = _react.useState.call(void 0, !1),
      _react$useState$call10 = _slicedToArray(_react$useState$call9, 2),
      m = _react$useState$call10[0],
      l = _react$useState$call10[1],
      _react$useState$call11 = _react.useState.call(void 0, !1),
      _react$useState$call12 = _slicedToArray(_react$useState$call11, 2),
      i = _react$useState$call12[0],
      f = _react$useState$call12[1],
      _react$useState$call13 = _react.useState.call(void 0, !1),
      _react$useState$call14 = _slicedToArray(_react$useState$call13, 2),
      d = _react$useState$call14[0],
      k = _react$useState$call14[1],
      F = _providers.useOnLinkClick.call(void 0),
      re = function re(v) {
    k(!1), F(v);
  },
      O = function O() {
    k(!0);
  },
      V = function V(v, C) {
    f(!!v), u(!C);
  },
      u = function u(v) {
    _optionalChain([t, 'optionalCall', function (_7) {
      return _7(v);
    }]), l(v);
  };

  return _react.useEffect.call(void 0, function () {
    return function () {
      _optionalChain([t, 'optionalCall', function (_8) {
        return _8(!1);
      }]);
    };
  }, [t]), _jsxruntime.jsxs.call(void 0, qo, {
    children: [_jsxruntime.jsxs.call(void 0, Ho, {
      children: [_jsxruntime.jsxs.call(void 0, Ao, {
        children: [_jsxruntime.jsx.call(void 0, Po, {
          color: "inverse",
          onClick: function onClick() {
            return V(!1, !!(m && !i));
          }
        }), _jsxruntime.jsx.call(void 0, _, {})]
      }), o ? _jsxruntime.jsxs.call(void 0, "div", {
        children: [_jsxruntime.jsx.call(void 0, _heartIcon.HeartIconMedium, {
          $marginRight: "16px",
          color: "inverse",
          cursor: "pointer",
          onClick: function onClick() {
            return F(S.href);
          }
        }), _jsxruntime.jsx.call(void 0, _userProfileIcon.UserProfileIconMedium, {
          color: "inverse",
          cursor: "pointer",
          onClick: function onClick() {
            return V(!0, !!(m && i));
          }
        })]
      }) : _jsxruntime.jsx.call(void 0, _button.Button, {
        onClick: r,
        children: "Sign In"
      }), _jsxruntime.jsx.call(void 0, Ae, {
        isProfile: i,
        isSignedIn: o,
        setShowDropdown: u,
        showDropdown: m,
        userData: s
      })]
    }), _jsxruntime.jsx.call(void 0, Mo, {
      children: _jsxruntime.jsx.call(void 0, _providers.LinkProvider, {
        onLinkClick: re,
        children: _jsxruntime.jsx.call(void 0, j, {
          currentHeaderGroup: e,
          onHeaderSearch: n,
          onHeaderSearchSubmitted: a,
          onShowSearch: O,
          searchSuggestions: c,
          setShowSearch: k,
          showSearch: d
        })
      })
    }), m && _jsxruntime.jsx.call(void 0, To, {})]
  });
},
    qo = _styledcomponents2.default.div(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: column;\n\n    @media (min-width: ", "px) {\n        display: none;\n    }\n"])), 1103 + 1),
    Ho = _styledcomponents2.default.div(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n    background: ", ";\n    height: 68.5px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 24px;\n    position: relative;\n"])), function (_ref30) {
  var e = _ref30.theme;
  return e.color.background.tertiary;
}),
    Po = _styledcomponents2.default.call(void 0, _menuHamburgerIcon.MenuHamburgerIconMedium)(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n    margin-right: 8px;\n    cursor: pointer;\n"]))),
    Mo = _styledcomponents2.default.div(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n    padding: 8px 24px;\n"]))),
    Ao = _styledcomponents2.default.div(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n    display: flex;\n"]))),
    To = _styledcomponents.createGlobalStyle(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n    body {\n        overflow: hidden;\n    }\n"])));

var _chevronDownIcon = require('@liveauctioneers/hammer-ui-core/icons/chevronDownIcon');

var _chevronUpIcon = require('@liveauctioneers/hammer-ui-core/icons/chevronUpIcon');

var Ie = function Ie(_ref31) {
  var e = _ref31.className,
      o = _ref31.links,
      n = _ref31.wouldOverflow;

  var a = _providers.useWindowWidth.call(void 0),
      t = _providers.usePreventDefaultLinkOnClick.call(void 0),
      r = _react.useMemo.call(void 0, function () {
    return !!(n && a < 1500);
  }, [n, a]);

  return _jsxruntime.jsx.call(void 0, $o, {
    $changeDropdownPosition: r,
    className: e,
    children: o.map(function (c) {
      return _jsxruntime.jsx.call(void 0, No, {
        href: c.href,
        onClick: t(c.href),
        size: "md",
        children: c.name
      }, c.href);
    })
  });
},
    $o = _styledcomponents2.default.div(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n    position: absolute;\n    padding: 8px 32px;\n    background: white;\n    top: 42px;\n    left: ", ";\n    display: flex;\n    flex-flow: column;\n    width: min-content;\n    border: 1px solid ", ";\n"])), function (_ref32) {
  var e = _ref32.$changeDropdownPosition;
  return e ? "-8px" : "0px";
}, function (_ref33) {
  var e = _ref33.theme;
  return e.color.border.divider.default;
}),
    No = _styledcomponents2.default.call(void 0, _link.SubtleMonochromeLink)(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n    display: flex;\n    margin: 8px 0;\n"])));

var X = function X(_ref34) {
  var e = _ref34.className,
      o = _ref34.currentHeaderGroup,
      n = _ref34.headerLink,
      a = _ref34.onHeaderClick,
      t = _ref34.setCurrentHeaderGroup,
      _ref34$wouldOverflow = _ref34.wouldOverflow,
      r = _ref34$wouldOverflow === void 0 ? !1 : _ref34$wouldOverflow;

  var c = _react.useRef.call(void 0, null),
      s = _react.useCallback.call(void 0, function (l) {
    !_optionalChain([c, 'access', function (_9) {
      return _9.current;
    }, 'optionalAccess', function (_10) {
      return _10.contains;
    }, 'call', function (_11) {
      return _11(l.target);
    }]) && o.length && t("");
  }, [o.length, t]);

  _react.useEffect.call(void 0, function () {
    return o.length && window.requestAnimationFrame(function () {
      window.addEventListener("click", s);
    }), function () {
      window.removeEventListener("click", s);
    };
  }, [o.length, s]);

  var m = o === n.name;
  return _jsxruntime.jsxs.call(void 0, jo, {
    className: e,
    onClick: function onClick() {
      return a(n.name);
    },
    ref: c,
    children: [_jsxruntime.jsxs.call(void 0, zo, {
      children: [_jsxruntime.jsx.call(void 0, Zo, {
        color: "inverse",
        children: n.name
      }), m ? _jsxruntime.jsx.call(void 0, _chevronUpIcon.ChevronUpIconSmall, {
        color: "inverse"
      }) : _jsxruntime.jsx.call(void 0, _chevronDownIcon.ChevronDownIconSmall, {
        color: "inverse"
      })]
    }), _jsxruntime.jsx.call(void 0, Jo, {
      $showDropdown: o === n.name,
      links: n.subLinks,
      wouldOverflow: r
    })]
  });
},
    jo = _styledcomponents2.default.div(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n    margin-left: 8px;\n    padding: 9px 16px;\n    display: flex;\n    justify-content: center;\n    flex-flow: column;\n    position: relative;\n    align-items: center;\n    white-space: nowrap;\n    z-index: 11;\n"]))),
    zo = _styledcomponents2.default.div(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n"]))),
    Zo = _styledcomponents2.default.call(void 0, _text.BodyPrimary)(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["\n    margin-right: 4px;\n    user-select: none;\n"]))),
    Jo = _styledcomponents2.default.call(void 0, Ie)(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["\n    ", "\n"])), function (_ref35) {
  var e = _ref35.$showDropdown;
  return !e && _styledcomponents.css(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["\n            height: 0;\n            width: 0;\n            padding: 0px;\n            border: none;\n            overflow: hidden;\n        "])));
});

var Ne = function Ne(_ref36) {
  var e = _ref36.currentHeaderGroup,
      o = _ref36.isSignedIn,
      n = _ref36.onHeaderClick,
      a = _ref36.onHeaderSearch,
      t = _ref36.onHeaderSearchSubmitted,
      r = _ref36.onSignInClicked,
      c = _ref36.searchSuggestions,
      s = _ref36.setCurrentHeaderGroup;

  var _react$useState$call15 = _react.useState.call(void 0, !1),
      _react$useState$call16 = _slicedToArray(_react$useState$call15, 2),
      m = _react$useState$call16[0],
      l = _react$useState$call16[1],
      i = _providers.useOnLinkClick.call(void 0),
      f = function f(k) {
    l(!1), i(k);
  };

  return _jsxruntime.jsx.call(void 0, ea, {
    children: _jsxruntime.jsxs.call(void 0, _providers.LinkProvider, {
      onLinkClick: f,
      children: [_jsxruntime.jsxs.call(void 0, ra, {
        children: [_jsxruntime.jsx.call(void 0, na, {
          children: _jsxruntime.jsx.call(void 0, _, {})
        }), _jsxruntime.jsx.call(void 0, j, {
          currentHeaderGroup: e,
          onHeaderSearch: a,
          onHeaderSearchSubmitted: t,
          onShowSearch: function onShowSearch() {
            s(""), l(!0);
          },
          searchSuggestions: c,
          setShowSearch: l,
          showSearch: m
        }), _jsxruntime.jsx.call(void 0, ta, {
          currentHeaderGroup: e,
          headerLink: oe[0],
          onHeaderClick: n,
          setCurrentHeaderGroup: s
        }), _jsxruntime.jsx.call(void 0, X, {
          currentHeaderGroup: e,
          headerLink: oe[1],
          onHeaderClick: n,
          setCurrentHeaderGroup: s
        })]
      }), _jsxruntime.jsx.call(void 0, oa, {
        children: o ? _jsxruntime.jsxs.call(void 0, _jsxruntime.Fragment, {
          children: [_jsxruntime.jsx.call(void 0, aa, {
            forwardedAs: "span",
            href: S.href,
            onClick: function onClick(k) {
              k.preventDefault(), f(S.href);
            },
            children: S.name
          }), _jsxruntime.jsx.call(void 0, X, {
            currentHeaderGroup: e,
            headerLink: b,
            onHeaderClick: n,
            setCurrentHeaderGroup: s,
            wouldOverflow: !0
          })]
        }) : _jsxruntime.jsx.call(void 0, _button.Button, {
          onClick: r,
          children: "Sign In"
        })
      })]
    })
  });
},
    ea = _styledcomponents2.default.div(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["\n    align-items: center;\n    display: grid;\n    grid-template-columns: 1fr min-content;\n    width: 100%;\n"]))),
    ra = _styledcomponents2.default.div(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    margin-right: 32px;\n    height: 100%;\n"]))),
    oa = _styledcomponents2.default.div(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n"]))),
    aa = _styledcomponents2.default.call(void 0, _link.SubtleInverseLink)(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["\n    white-space: nowrap;\n"]))),
    na = _styledcomponents2.default.div(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["\n    margin-right: 16px;\n    display: flex;\n    align-items: center;\n    height: 100%;\n"]))),
    ta = _styledcomponents2.default.call(void 0, X)(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["\n    margin-left: 16px;\n"])));

var Dt = function Dt(_ref37) {
  var e = _ref37.className,
      o = _ref37.isSignedIn,
      n = _ref37.onHeaderSearch,
      a = _ref37.onHeaderSearchSubmitted,
      t = _ref37.onSetBodyHidden,
      r = _ref37.onSignInClicked,
      _ref37$searchSuggesti = _ref37.searchSuggestions,
      c = _ref37$searchSuggesti === void 0 ? [] : _ref37$searchSuggesti,
      s = _ref37.userData;

  var m = _react.useRef.call(void 0, null),
      _react$useState$call17 = _react.useState.call(void 0, ""),
      _react$useState$call18 = _slicedToArray(_react$useState$call17, 2),
      l = _react$useState$call18[0],
      i = _react$useState$call18[1];

  return _jsxruntime.jsxs.call(void 0, _jsxruntime.Fragment, {
    children: [_jsxruntime.jsx.call(void 0, Be, {
      currentHeaderGroup: l,
      isSignedIn: o,
      onHeaderSearch: n,
      onHeaderSearchSubmitted: a,
      onSetBodyHidden: t,
      onSignInClicked: r,
      searchSuggestions: c,
      userData: s
    }), _jsxruntime.jsx.call(void 0, ca, {
      className: e,
      children: _jsxruntime.jsxs.call(void 0, ma, {
        ref: m,
        children: [_jsxruntime.jsx.call(void 0, Ne, {
          currentHeaderGroup: l,
          isSignedIn: o,
          onHeaderClick: function onHeaderClick(d) {
            i(l !== d ? d : "");
          },
          onHeaderSearch: n,
          onHeaderSearchSubmitted: a,
          onSignInClicked: r,
          searchSuggestions: c,
          setCurrentHeaderGroup: i
        }), _jsxruntime.jsx.call(void 0, fe, {
          currentHeaderGroup: l,
          setCurrentHeaderGroup: i
        })]
      })
    })]
  });
},
    ca = _styledcomponents2.default.header(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["\n    background: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    position: relative;\n\n    @media (max-width: ", "px) {\n        display: none;\n    }\n"])), function (_ref38) {
  var e = _ref38.theme;
  return e.color.background.tertiary;
}, 1103),
    ma = _styledcomponents2.default.div(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-rows: 74px 50px;\n    max-width: ", ";\n    width: 100%;\n    padding: 0 24px;\n"])), function (_ref39) {
  var e = _ref39.theme;
  return e.breakpoints.xlMin;
});

exports.Header = Dt;
exports.aboutAuctionsLinks = D;
exports.browseByLinks = B;
exports.categoryLinks = E;
exports.headerTopLeftLinks = oe;
exports.myAccountLinks = b;
exports.myWatchListLink = S;